export default __webpack_public_path__ + "static/media/success-shift-logo.5178c1eb.svg";